import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { reduxForm, Field } from "redux-form";
import Modal from "../boxes/Modal";
import LoadingScreen from "../LoadingScreen";
import { ApiService, ENDPOINTS } from "../../services/ApiService";
import { withTranslation } from "react-i18next";

class DoctorOfflineSelectModal extends Component {
  constructor(props) {
    super(props);

    this.service = new ApiService(props.accessToken);

    this.state = {
      error: null,
    };
  }

  createNewConsultation = (values) => {
    const { consultation } = this.props;

    const data = {
      medium_id: consultation.medium_id,
      patient_id: consultation.patient.id,
      doctor_id:
        values.select_wait_option === "yes" ? consultation.doctor.id : null,
      previous_consultation_id: consultation.id,
      reason: values.content,
    };

    this.service
      .post(ENDPOINTS.consultations.consultation, data)
      .then((response) => {
        window.location.href = `/consultations/${response.data.consultation_id}/messages`;
      })
      .catch((error) => {
        this.setState({
          error,
        });
        console.log(error);
      });
  };

  render() {
    const { handleSubmit, pristine, submitting } = this.props;
    const { consultation, t } = this.props;

    return (
      <Modal
        onClose={this.props.onClose}
        title={t("doctorOfflineSelectionModalTitle")}
      >
        {!consultation ? (
          <LoadingScreen />
        ) : (
          <div className="dashboard-card e2e-doctor-offline-modal">
            <form
              className="dashboard-form"
              onSubmit={handleSubmit(this.createNewConsultation)}
            >
              <div className="dashboard-form-item-wrapper">
                <div className="dashboard-input-wrap profile-input-wrap">
                  <p>
                    {t("doctorOffline", {
                      firstName: consultation.doctor.first_name,
                      lastName: consultation.doctor.last_name,
                    })}
                  </p>
                  <span className="dashboard-form-item">
                    <label className="profile-item__label" htmlFor="">
                      {t("waitTillDoctorIsOnlineFieldLabel", {
                        firstName: consultation.doctor.first_name,
                        lastName: consultation.doctor.last_name,
                      })}
                    </label>
                    <Field
                      component="select"
                      name="select_wait_option"
                      className="dashboard-form__input"
                      placeholder={t("waitOptionDropdownPlaceholder")}
                      type="text"
                    >
                      <option>{t("defaultDropdownOptionLabel")}</option>
                      <option value="yes">{t("yesDropdownOptionLabel")}</option>
                      <option value="no">{t("noDropdownOptionLabel")}</option>
                    </Field>
                  </span>
                </div>
              </div>
              <button
                disabled={pristine || submitting}
                className="dashboard__primary-btn dashboard-form__btn"
              >
                {t("formSubmitButtonText")}
              </button>
            </form>
          </div>
        )}
      </Modal>
    );
  }
}

DoctorOfflineSelectModal = reduxForm({
  form: "doctorOfflineSelectModal",
})(DoctorOfflineSelectModal);

const DoctorOfflineSelectionFormWithTranslation = withTranslation([
  "consultations",
])(DoctorOfflineSelectModal);

export default withRouter(DoctorOfflineSelectionFormWithTranslation);
